import { helper } from '@ember/component/helper';
import { assert } from '@ember/debug';
import { set as emberSet } from '@ember/object';

// set returns a function that assigns to `path` on `target`, replacing the
// `{{action (mut this.foo)}}` pattern that `template-action` deprecates.
//
//   {{action (mut this.foo)}}          ->  {{set this "foo"}}
//   {{action (mut this.foo) "bar"}}    ->  {{set this "bar-value"}}
//   {{action (mut contact.notes)}}     ->  {{set contact "notes"}}
//
// With two arguments the returned function takes the new value, so it drops
// straight into an `@onChange`. With three, the value is fixed up front and the
// returned function ignores what it is called with, which suits `{{on "click"}}`.
export function set([target, path, value], _hash, arity) {
  assert(
    'set requires a string path, e.g. {{set this "foo"}}',
    typeof path === 'string' && path.length > 0,
  );
  return arity === 3
    ? () => emberSet(target, path, value)
    : (newValue) => emberSet(target, path, newValue);
}

export default helper(function (positional) {
  return set(positional, undefined, positional.length);
});
